import { z } from 'zod';
import { NUMBER_MAX, NUMBER_MIN } from './constants.js';
import { V1_GAME_NAMES } from './game-rules.js';

/**
 * Request to sell a ticket. Minimal, transport-agnostic shape; the server layer
 * adds identity (teller), draw allocation and durability. Mirrors the meaningful
 * fields of v1 createTicketSchema (game type + numbers + bet) but names the game
 * type instead of a DB id and keeps the bet in integer minor units.
 */
export const saleRequestSchema = z
  .object({
    gameType: z.enum(V1_GAME_NAMES),
    selections: z.array(z.number().int().min(NUMBER_MIN).max(NUMBER_MAX)).default([]),
    betMinor: z.number().int().positive(),
  })
  .refine((v) => v.gameType !== 'number' || v.selections.length > 0, {
    message: 'the "number" game requires at least one selected number',
    path: ['selections'],
  });

export type SaleRequest = z.infer<typeof saleRequestSchema>;

/**
 * Request to pay out a ticket. Carries the printed public ticket number (counter
 * + Damm check digit); the server validates the check digit and the already-paid
 * guard (BLUEPRINT §4).
 */
export const payoutRequestSchema = z.object({
  ticketNumber: z.string().regex(/^\d+$/, 'ticket number must contain digits only'),
});

export type PayoutRequest = z.infer<typeof payoutRequestSchema>;
